document.addEventListener("DOMContentLoaded", function () {
  console.log("✅ Custom User Inputs JS Loaded!");

  let observer;
  let debounceTimeout = null;

  // =============================
  // 🚀 SECTION 1: INTERCEPT "ADD TO CART" & SHOW MODAL
  // =============================

  function attachEventListeners() {
    const addToCartButton = document.querySelector("button[name='add']");
    if (!addToCartButton) {
      console.warn("⚠ Add to Cart button not found yet. Waiting...");
      return;
    }

    const modal = document.getElementById("custom-user-input-modal");
    const closeButton = document.querySelector(".modal .close");
    const continueButton = document.getElementById("continue-to-cart");

    if (!modal || !closeButton || !continueButton) {
      console.warn("⚠ Modal elements not found yet. Waiting...");
      return;
    }

    const form = addToCartButton.closest("form[action*='/cart/add']");
    if (!form) {
      console.warn("⚠ Product form not found yet. Waiting...");
      return;
    }

    // ✅ Prevent duplicate event bindings on the same DOM elements
    if (
      addToCartButton.dataset.customInputsBound === "true" &&
      closeButton.dataset.customInputsBound === "true" &&
      continueButton.dataset.customInputsBound === "true"
    ) {
      return;
    }

    addToCartButton.dataset.customInputsBound = "true";
    closeButton.dataset.customInputsBound = "true";
    continueButton.dataset.customInputsBound = "true";

    console.log("✅ Add to Cart button detected!");

    // ✅ Ensure modal is hidden on page load
    modal.style.display = "none";

    // ✅ Intercept "Add to Cart" click before Shopify's default action
    addToCartButton.addEventListener("click", function (event) {
      console.log("🚀 Add to Cart button clicked!");
      event.preventDefault();
      event.stopImmediatePropagation();
      modal.style.display = "flex";
    });

    // ✅ Close Modal when clicking "X"
    closeButton.addEventListener("click", function () {
      modal.style.display = "none";
      console.log("✅ Modal closed via 'X' button.");
    });

    // ✅ Prevent Add to Cart if required fields are empty
    continueButton.addEventListener("click", function (event) {
      event.preventDefault();
      console.log("🚀 Continue to Cart button clicked - Checking validation...");
      let isValid = true;

      let requiredFields = document.querySelectorAll(
        "#custom-user-input-form .form-group:not(.hidden) [required]"
      );

      console.log("🔍 Required Fields Detected:", requiredFields.length);

      requiredFields.forEach((input) => {
        let fieldValid = true;

        if (input.type === "radio" && !document.querySelector(`input[name="${input.name}"]:checked`)) {
          fieldValid = false;
        } else if (input.tagName === "SELECT" && !input.value) {
          fieldValid = false;
        } else if (input.type !== "radio" && !input.value.trim()) {
          fieldValid = false;
        } else if (input.hasAttribute("data-pattern")) {
          let customPattern = input.getAttribute("data-pattern");
          let errorMessage = input.getAttribute("data-pattern-message") || "Invalid format.";

          console.log("🔍 Checking pattern:", customPattern, "For input:", input.name || input.id);

          try {
            let regex = new RegExp(`^${customPattern}$`);
            console.log("✅ Regex compiled successfully:", regex);

            // Normalize Input: Trim spaces
            let inputValue = input.value.trim();

            // ✅ Auto-capitalize if pattern requires uppercase letters
            if (customPattern.includes("A-Z")) {
              inputValue = inputValue.toUpperCase();
              input.value = inputValue;
            }

            console.log(`🔍 Normalized Input: "${inputValue}" testing against: "${customPattern}"`);

            if (!regex.test(input.value)) {
              console.warn(`⚠ Input does not match required pattern: ${customPattern}`);
              fieldValid = false;
              input.style.border = "2px solid red";

              // Remove existing error message if it exists
              let existingMessage = input.nextElementSibling;
              if (existingMessage && existingMessage.classList.contains("error-message")) {
                existingMessage.remove();
              }

              // Create and show error message
              let errorDiv = document.createElement("div");
              errorDiv.classList.add("error-message");
              errorDiv.style.color = "red";
              errorDiv.style.fontSize = "12px";
              errorDiv.style.marginTop = "5px";
              errorDiv.textContent = errorMessage;
              input.parentNode.insertBefore(errorDiv, input.nextSibling);
            } else {
              input.style.border = "";

              // ✅ Remove error message when input becomes valid
              let existingMessage = input.nextElementSibling;
              if (existingMessage && existingMessage.classList.contains("error-message")) {
                existingMessage.remove();
              }
            }
          } catch (error) {
            console.error(`❌ Invalid RegExp detected: "${customPattern}"`, error);
            fieldValid = false;
          }
        }

        if (!fieldValid) {
          isValid = false;
          input.style.border = "2px solid red";
        } else {
          input.style.border = "";
        }
      });

      if (!isValid) {
        console.warn("⚠ Please fill all required fields. Submission prevented.");
        return;
      }

      console.log("✅ All required fields are filled, preparing to submit...");

      // ✅ Remove previously appended custom fields before adding fresh ones
      form.querySelectorAll("[data-custom-user-input='true']").forEach((input) => input.remove());

      // ✅ Remove hidden field values before submitting
      console.log("🗑 Removing hidden fields before submission...");
      document
        .querySelectorAll("#custom-user-input-form .hidden input, #custom-user-input-form .hidden select, #custom-user-input-form .hidden textarea")
        .forEach((input) => {
          console.log(`🚫 Removing hidden field: ${input.name || input.id} (Value: "${input.value}")`);
          input.remove();
        });

      // ✅ Move all ALWAYS VISIBLE & CONDITIONAL VISIBLE user inputs to Shopify's cart form
      console.log("📤 Moving visible fields to Shopify's cart form...");
      document
        .querySelectorAll("#custom-user-input-form .form-group input, #custom-user-input-form .form-group select, #custom-user-input-form .form-group textarea")
        .forEach((input) => {
          if (!input.closest(".hidden")) {
            const fieldKey = input.name || input.id;
            const fieldValue = input.type === "radio" ? (input.checked ? input.value : null) : input.value.trim();

            if (fieldValue === null) {
              return;
            }

            console.log(`✅ Keeping field: ${fieldKey} (Value: "${fieldValue}")`);

            const clone = input.cloneNode(true);
            clone.style.display = "none";
            clone.name = `${fieldKey}`;
            clone.value = fieldValue;
            clone.setAttribute("data-custom-user-input", "true");

            form.appendChild(clone);
            console.log(`📌 Appended to form: properties[${fieldKey}] (Value: "${clone.value}")`);
          } else {
            console.log(`🔹 Skipped hidden field: ${input.name || input.id}`);
          }
        });

      console.log("✅ Validation passed. Closing modal and submitting form.");
      modal.style.display = "none";

      if (typeof form.requestSubmit === "function") {
        form.requestSubmit();
      } else {
        const submitButton = form.querySelector("button[type='submit'], input[type='submit']");
        if (submitButton) {
          submitButton.click();
        } else {
          form.submit();
        }
      }
    });

    // ✅ Close Modal when clicking outside the box
    window.onclick = function (event) {
      if (event.target === modal) {
        modal.style.display = "none";
      }
    };

    // ✅ Ensure radio and select inputs trigger conditional updates
    document.querySelectorAll("input[type='radio'], select").forEach((input) => {
      if (input.dataset.conditionalBound !== "true") {
        input.dataset.conditionalBound = "true";
        input.addEventListener("change", updateConditionalFields);
      }
    });
  }

  // =============================
  // 🚀 SECTION 2: MANAGE CONDITIONAL FIELDS BASED ON JSON
  // =============================

  function updateConditionalFields() {
    console.log("🔄 Checking conditional fields...");

    document.querySelectorAll(".form-group").forEach((field) => {
      const conditionField = field.getAttribute("data-conditional");
      const expectedValue = field.getAttribute("data-value");
      const orConditions = field.getAttribute("data-conditional-or");

      let parsedOrConditions = [];
      try {
        parsedOrConditions = orConditions ? JSON.parse(orConditions) : [];
        if (!Array.isArray(parsedOrConditions)) {
          parsedOrConditions = [];
        }
      } catch (error) {
        console.error(`❌ Error parsing conditional_or JSON:`, error);
        parsedOrConditions = [];
      }

      let shouldShow = false;

      // ✅ 1. Always Visible Fields (No Conditions)
      if (!conditionField && parsedOrConditions.length === 0) {
        console.log(`🟢 Always Visible: ${field.querySelector("label")?.innerText || "Unknown Field"}`);
        shouldShow = true;
      }

      // ✅ 2. Handle `conditional` logic (Single Condition)
      if (conditionField && expectedValue) {
        let triggerInput = document.getElementById(conditionField.toLowerCase().replace(/\s+/g, "_"));
        if (triggerInput) {
          if (triggerInput.tagName === "SELECT") {
            shouldShow = triggerInput.value === expectedValue;
          } else if (triggerInput.type === "radio") {
            shouldShow = triggerInput.checked && triggerInput.value === expectedValue;
          } else {
            shouldShow = triggerInput.value === expectedValue;
          }
        }
      }

      // ✅ 3. Handle `conditional_or` logic (Multiple OR Conditions)
      if (parsedOrConditions.length > 0) {
        let orMatched = parsedOrConditions.some((condition) => {
          let triggerInput = document.getElementById(condition.field.toLowerCase().replace(/\s+/g, "_"));
          if (triggerInput) {
            if (triggerInput.tagName === "SELECT") {
              return triggerInput.value === condition.value;
            }
            return triggerInput.value === condition.value;
          }
          return false;
        });

        if (orMatched) {
          shouldShow = true;
        }
      }

      // ✅ 4. Apply Visibility Changes
      if (shouldShow) {
        field.classList.remove("hidden");
        field.querySelectorAll("input, select, textarea").forEach((input) => input.setAttribute("required", "true"));
      } else {
        field.classList.add("hidden");
        field.querySelectorAll("input, select, textarea").forEach((input) => {
          input.removeAttribute("required");
          input.value = "";
        });
      }
    });
  }

  // =============================
  // 🚀 SECTION 3: OBSERVE SHOPIFY CHANGES & ATTACH LISTENERS
  // =============================

  observer = new MutationObserver(() => {
    const modal = document.getElementById("custom-user-input-modal");
    const isModalOpen = modal && modal.style.display === "flex";

    if (debounceTimeout) clearTimeout(debounceTimeout);

    debounceTimeout = setTimeout(() => {
      attachEventListeners();
      updateConditionalFields();

      // ✅ Restore modal state if it was open before refresh
      if (isModalOpen && modal) {
        modal.style.display = "flex";
        console.log("🔄 Modal was open before refresh, keeping it visible.");
      }
    }, 500);
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // ✅ Attach all functionality on first load
  attachEventListeners();
  updateConditionalFields();
});